import TableList from "@components/templates/tablelist";
import {
    HttpCustomerMageFindPage
} from "@/service/account";
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {},
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_accountStatus: null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpCustomerMageFindPage,
    },
    computed: {
        ...mapGetters("dictionary", ["getOrgList"]),
        ...mapGetters("common", ['getCustomermanageAccountStatue']),
        TabsData() {
            return [
                {
                    name: "所有",
                    key: 'EQ_accountStatus',
                    val: null
                },
                {
                    name: "欠费",
                    key: 'EQ_accountStatus',
                    val: 1
                },
                {
                    name: "冻结",
                    key: 'EQ_accountStatus',
                    val: 3
                }
            ]
        },
        ToolsData() { },
        SearchsData() {
            return [
                {
                    label: "客户",
                    tag: "vSelect",
                    key: "EQ_organizationId",
                    options: this.getOrgList,
                    show: true,
                    props: {
                        filterable: true
                    }
                },
                {
                    label: "账户状态",
                    tag: 'vSelect',
                    key: 'EQ_accountStatus',
                    options: this.getCustomermanageAccountStatue,
                    show: true,
                    props: {
                        filterable: true,
                        dropStyle: ''
                        //text-align:center //居中
                    }
                },
            ];
        },
        columns() {
            return [
                {
                    title: "客户",
                    key: "orgId",
                    render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.orgId)
                },
                {
                    title: "账户状态",
                    key: "accountStatus",
                    render: (h, { row }) => this.findRenderLabel(this.getCustomermanageAccountStatue, row.accountStatus)
                },
                {
                    title: "账户可用余额（USD）",
                    key: "availableAmount"
                },
                {
                    title: "信用额度可用余额（USD）",
                    key: "creditAvailableQuota",
                },
                {
                    title: "信用总额度（USD）",
                    key: "totalQuota",
                }
            ];
        }
    }
};
